module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h1', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "ieioh"
    }
  }), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDELIBLY")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TCHED IN")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARTS")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v("The real test of friendship is…. Can you enjoy together those moments of life that are utterly simple? They are the moments people look back on at the end of life and number as their most sacred experiences.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGENE")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNEDY")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('i', [_vm._v("What is it about friends that is so special?")]), _vm._v(" Why out of all the people we come across in our lives do we form attachments to certain folks, attachments so strong that even the thought of them brings a smile to our faces? Each of us has his or her own answer to those questions, but no matter how we understand "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("the connection, there's no doubt that our friendships play a huge part in making our lives worth living.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("For years now, I have been collecting stories of ordinary people's simple pleasures, the homey little things that give life its zest—a hot bath, the first smell of lilacs in spring, the sight of grey and black juncos against a snowdrift. I've looked at what gives us delight inside our homes and outside in our gardens. I've asked folks to share what traditions give holidays their special meaning. In three books, I have explored the pleasures of the material world that we can have at low or no cost, encouraging us all to consider how to fold more joy and comfort into our daily lives.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("This book is different. It is a celebration, not of the world of objects, but of the pleasures of the most precious gift any person can ever receive: friendship.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("What are the simple pleasures of friendship? That's what I set out to discover and commemorate when I sent out a notice to writers' groups around the world, asking for contributions. I received contributions from South Africa and Australia, Mexico, Malaysia, India, England, and all fifty of the United States. Contributors ranged in age from a twelve year old to folks in their seventies.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Reading the hundreds of submissions, I quickly saw themes: in particular, the satisfaction of staying in touch across time and space (there were dozens of stories about the joys of e-mail and long-distance phone calls) and the joys of unlikely friendship "), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v("between people seemingly very different (I could have filled an entire book with intergenerational friendship stories alone). There was the happiness of reuniting after a long time, on the one hand, and of daily contact on the other. There was the pleasure of lifelong connection and the delight of the briefest encounter. All are celebrated moments in time—large or small—with one friend or many who are indelibly etched in their hearts.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Overall, three common threads emerged: friends bring us the pleasure of play by joining us in life's fun adventures. They bring us the pleasure of comfort by being there in times of trouble. And they bring us the pleasure of understanding, as they witness the unfolding of our lives over time. So that's how the book is organized.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("It is my hope that in reading these stories, you will experience double pleasure: first at the warm feelings the authors express toward their friends, and second at your memories of similar times with your own. And because my guess is that the stories will prompt you to reach out to the friends in your life, I also offer dozens of easy-to-make gifts and recipes to share with the special folks who make up your friendship circle.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Friendship is truly one of life's simple pleasures. No amount of money can purchase it. We can't fake it—we either feel it or not. We can't make it happen. We experience it by being ourselves, in communion with others being themselves—people whom we feel a special connection to. Simple? Yes, but mysterious and profound, too.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _vm._v("May this book help you remember the joy that friendship brings you, may it help you forge even stronger bonds to those you count as friends, and may your life always be filled with the pleasure of good friends.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Susannah Seton")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76eb26ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_indelibly.vue
// module id = 75
// module chunks = 0